import React, { useMemo } from "react";
import { ResponsiveLine } from "@nivo/line";
import { useState } from "react";
import { useWindowSize } from "../../../global/hooks/viewportHooks";
import {
  fetchRulesEndPoint,
  fetchV1HistoryEndPoint,
} from "../../../configuration";
import { getRandomUUID } from "../../../Token";
import { useSelector } from "react-redux";

export const LineChartUI = ({
  finalKeys,
  sensorData,
  legend,
  ble,
  bottom = false,
  lora = false,
  timeInterval = false,
  setLastUpdatedReading,
}) => {
  const { activeSession } = useSelector(
    (state) => state.sessionReducer.activeSession
  );
  let tempWidth = useWindowSize();

  let width = tempWidth.width;
  //Groupby function
  let fieldQuery = legend;
  console.log(fieldQuery);
  const dummyData = [
    {
      id: fieldQuery,
      color: "grey",
      data: [
        {
          x: "",
          y: 0,
        },
      ],
    },
  ];
  const [deviceData, setDeviceData] = useState(dummyData);
  const [thresHold, setThresHold] = useState();
  const [minDate, setMinDate] = useState();
  const [maxDate, setMaxDate] = useState();
  const [minValue, setMinValue] = useState();
  const [maxValue, setMaxValue] = useState();
  //Extract fields needed in order to call event field history line chart
  let deviceId = sensorData.data.uid;

  //need some logic here to determine the fields to extract
  useMemo(() => {
    let mounted = false;
    if (!mounted) {
      console.log("Here in SensorLineChartV1.jsx");

      fetch(fetchRulesEndPoint(), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          // Redis mode: no sessionToken in Redux — session lives in HttpOnly cookie sent via withCredentials
          // Legacy mode: sessionToken is present, attach it as Bearer
          ...(activeSession.sessionToken && { Authorization: `Bearer ${activeSession.sessionToken}` }),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          accountName: activeSession.accountId,
        }),
      })
        .then((response) => response.json())
        .then((fetchRuleRsp) => {
          if (fetchRuleRsp.error) {
            console.log(fetchRuleRsp);
          }
          if (!fetchRuleRsp.error) {
            // console.log(fetchRuleRsp);
            let ruleData = fetchRuleRsp;
            for (let i = 0; i < ruleData.length; i++) {
              let ruleDetail = {};

              let deviceInfo;
              if (ruleData[i].deviceid) {
                if (
                  ruleData[i].deviceid === sensorData.data.uid &&
                  ruleData[i].condition.includes(
                    legend.charAt(0).toUpperCase() + legend.slice(1)
                  )
                ) {
                  // console.log("threshold", ruleData[i].condition)
                  // console.log("threshold", ruleData[i].condition.split("< ")[1])
                  // console.log("field type", legend.charAt(0).toUpperCase() + legend.slice(1))
                  let tempThresHold = ruleData[i].condition.split("< ")[1];
                  setThresHold(tempThresHold);
                }
              }
            }
          }
        });

      //get device list
      fetch(fetchV1HistoryEndPoint(fieldQuery), {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          ...(activeSession.sessionToken && { Authorization: `Bearer ${activeSession.sessionToken}` }),
          "VZ-M2M-Token": getRandomUUID(),
        },
        body: JSON.stringify({
          accountname: activeSession.accountId,
          resourceidentifier: {
            deviceid: deviceId,
          },
        }),
        filter: {
          $nopagination: true,
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (response.error) {
            if (
              response.error_description ===
              "Invalid token type in Authorization header."
            ) {
              alert("Invalid Token, Please login first");
              return;
            } else if (response.error === "unauthorized_client") {
              alert(
                "This user is not authorized to fetch device list, please log in as device user"
              );
              return;
            }
          }
          console.log("response from device history", response);
          const compData = showEveryDataPoint(
            response,
            fieldQuery,
            sensorData,
            ble,
            bottom
          );
          // console.log("compData", compData)
          // //if (deviceData != compDataInitial)
          setDeviceData(compData);
          let data = compData[0].data;
          // console.log("min date", data[0].x)
          // console.log("max date", data[data.length-1].x)

          setMinDate(data[0].x);
          setMaxDate(data[data.length - 1].x);
          setLastUpdatedReading(data[data.length - 1].x);
          let minVal = data.reduce(function (prev, curr) {
            return prev.y < curr.y ? prev : curr;
          });

          let maxVal = data.reduce(function (prev, curr) {
            return prev.y > curr.y ? prev : curr;
          });

          setMinValue(minVal.y);
          setMaxValue(maxVal.y);

          //parsing logic goes here
          //after getting response logic to parse the data and prepare for line chart
        })
        .catch((error) => {
          console.log(error); //error handler for device list endpoint
        });
    }
    return () => {
      mounted = true;
    };
    //IF THE SELECTED FIELD CHANGES WE TRIGGER THIS
  }, [fieldQuery]);

  const theme = {
    legends: {
      text: {
        fontSize: 15,
      },
    },
    axis: {
      legend: {
        text: {
          fontSize: 19,
        },
      },
      ticks: {
        text: {
          fontSize: 14,
        },
      },
    },
  };

  return (
    <ResponsiveLine
      theme={{
        legends: {
          text: {
            fontSize: 15,
          },
        },
        axis: {
          legend: {
            text: {
              fontSize: 19,
            },
          },
          ticks: {
            text: {
              fontSize: 14,
            },
          },
        },
      }}
      //maxValue={typeof maxValue === "undefined" ? null : maxValue+100}
      data={deviceData === undefined ? [] : deviceData}
      margin={
        bottom
          ? { top: 10, right: 200, bottom: 85, left: 200 }
          : { top: 20, right: 120, bottom: 60, left: 120 }
      }
      xScale={{ type: "point", min: 0, max: 100 }}
      yScale={{
        type: "linear",
        min: bottom ? -120 : !bottom && minValue ? minValue - 1 : "auto",
        max: bottom ? -0 : !bottom && maxValue ? maxValue + 1 : "auto",
        // min: (!bottom && minValue) ? minValue -1 : "auto",
        // max: (!bottom && maxValue) ? maxValue +1 : "auto",
        stacked: false,
        reverse: false,
      }}
      gridYValues={20}
      yFormat=" >-.2f"
      curve="catmullRom"
      axisTop={null}
      axisRight={null}
      axisBottom={{
        orient: "bottom",
        tickPadding: 10,
        legendOffset: 43,
        legendPosition: "middle",
        legend: "Time ",
        theme: { theme },
        renderTick: ({ textX, textY, value, x, y }) => {
          if (!(value === minDate || value === maxDate)) return "";

          const [val1, val2] = new Date(value.trim())
            .toLocaleString([], { hour12: true })
            .split(", ");
          return (
            <>
              <g transform={`translate(${x - 30},${y + 25})`}>
                <text transform={`translate(${textX},${textY})`}>{val1}</text>
              </g>
              <g transform={`translate(${x - 30},${y + 40})`}>
                <text transform={`translate(${textX},${textY + 30})`}>
                  {val2}
                </text>
              </g>
            </>
          );
        },
        tickSize: function (value) {
          return 2;
        },
      }}
      axisLeft={{
        orient: "left",
        tickSize: 3,
        tickPadding: 5,
        tickRotation: 0,
        legendOffset: -60,
        legendPosition: "middle",
        legend: legend,
      }}
      markers={
        typeof thresHold !== "undefined"
          ? [
              {
                axis: "y",
                value: thresHold,
                legend: "Threshold",
                lineStyle: {
                  stroke: "red",
                },
                textStyle: {
                  fill: "red",
                },
              },
            ]
          : null
      }
      pointSize={1}
      s
      pointColor={{ theme: "background" }}
      pointBorderWidth={2}
      pointBorderColor={{ from: "serieColor" }}
      pointLabelYOffset={-25}
      useMesh={true}
      columns={{ xs: 0, sm: 6, md: 12 }}
      colors={"black"} //hard coded
      legends={[
        {
          anchor: "bottom-right",
          direction: "column",
          justify: false,
          translateX: 90,
          translateY: -30,
          itemsSpacing: 0,
          itemDirection: "left-to-right",
          itemWidth: 80,
          itemHeight: 20,
          itemOpacity: 0.75,
          symbolSize: 12,
          symbolShape: "circle",
          symbolBorderColor: "rgba(0, 0, 0, .5)",
          effects: [
            {
              on: "hover",
              style: {
                itemBackground: "rgba(0, 0, 0, .03)",
                itemOpacity: 1,
              },
            },
          ],
        },
      ]}
      layers={[
        "grid",
        "markers",
        "axes",
        "areas",
        "crosshair",
        "lines",
        "slices",
        "points",
        "mesh",
        "legends",
      ]}
    />
  );
};

function groupBy_Date() {
  return function (xs, key) {
    // console.log(xs, key);
    if (xs) {
      return xs?.reduce(function (rv, x) {
        (rv[x[key]] = rv[x[key]] || []).push(x["y"]);
        return rv;
      }, {});
    } else {
    }
  };
}

function getMarkers(thresHold) {
  let markers = [
    {
      axis: "y",
      value: thresHold,
      legend: "Threshold",
      lineStyle: {
        stroke: "red",
      },
      textStyle: {
        fill: "red",
      },
    },
  ];

  let finalMarks = typeof thresHold !== "undefined" ? markers : "markers";
  return finalMarks;
}

function showEveryDataPoint(response, fieldQuery, sensorData, ble, bottom) {
  let eventHistory = getDateAndFieldValueV1(response, fieldQuery, ble, bottom);
  eventHistory = eventHistory?.sort(function (a, b) {
    var c = new Date(a.x);
    var d = new Date(b.x);
    console.log(c, d);
    return c - d;
  });
  //]console.log("eventHistory", eventHistory);
  //console.log("sensorData in showEveryDataPoint", sensorData)
  let groupByDate = groupBy_Date();
  let groupByDateData = groupByDate(eventHistory, "x");
  //console.log("groupByDateData", groupByDateData);
  let lineChartData = prepareDataForLineChartV1(groupByDateData, ble, bottom);
  //console.log("lineChartData", lineChartData);
  const compData = [
    {
      id: fieldQuery,
      color: "gray",
      data: lineChartData,
    },
  ];
  return compData;
}

function calculateAverage(array) {
  var total = 0;
  var count = 0;

  array.forEach(function (item, index) {
    let val = item;
    if (typeof item === "string") {
      val = parseInt(item);
    }

    total += val;
    count++;
  });

  return total / count;
}

function prepareDataForLineChartV1(groupByDateData, ble, bottom) {
  let finalLineData = [];
  let keys = groupByDateData && Object.keys(groupByDateData);
  //Average function
  //console.log("keys in prepareDataForLineChartV1", keys)

  let modulus = bottom ? 5 : 2;
  for (let i = 0; i < keys?.length; i++) {
    //Key is date
    let date = keys[i];
    let field_values = groupByDateData[date];
    //console.log("date key ", date)
    //console.log("field values to be averaged", field_values)
    //Calculating average of field for each date
    let avg = calculateAverage(field_values);

    finalLineData.push({
      x: date,
      y: Number(avg.toFixed(2)), //Two decimal places
    });
  }
  //Sort data by date
  finalLineData?.sort(function (a, b) {
    var c = new Date(a.x);
    var d = new Date(b.x);
    return c - d;
  });
  //console.log("finalLineData", finalLineData)
  return finalLineData;
}

function getDateAndFieldValueV1(eventHistory, field, ble, bottom) {
  //console.log("eventHistory in getDateAndFieldValueV1", eventHistory)
  return eventHistory?.map((eventData) => {
    // "Wed Jun 29 2011 09:52:48 GMT-0700 (PDT)"
    //console.log("eventData", eventData);
    let time = eventData.createdon;
    // console.log("time", time);
    // console.log("date time", Date(time));
    // console.log("time.split", time.split("T"));

    let date = new Date(time);
    let formattedDate = date.toLocaleString("en-US");

    //no matter what we re returning the formatted date
    return {
      x: formattedDate,
      y: eventData.fields[field],
    };
  });
}
